<div class="partner-products-container">

  <div class="header">
    <h2>Produkty za punkty</h2>

    <div class="campaigns-toolbar">
      <button mat-raised-button class="custom-button" (click)="openDialog()">
        <mat-icon>add</mat-icon> Dodaj produkt
      </button>
    </div>
  </div>




  @if (loading) {
    <div class="loading-container">
      <mat-progress-spinner diameter="48"></mat-progress-spinner>
    </div>
  }

  @if (!loading && items.length === 0) {
    <div class="no-data">
      <mat-icon>inventory_2</mat-icon>
      <p>Brak produktów do wyświetlenia</p>
    </div>
  }

  @if (!loading && items.length > 0) {
    <div class="table-wrapper">
      <table mat-table [dataSource]="items" class="products-table">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let item">{{ item.id }}</td>
        </ng-container>
        <ng-container matColumnDef="file">
          <th mat-header-cell *matHeaderCellDef>Zdjęcie</th>
          <td mat-cell *matCellDef="let item">
            @if (item.file) {
              <img width="120" [src]="imagesUrl + '/partner_products/thumb/' + item.file"
                class="thumb" alt="" />
            }
            @if (!item.file) {
              <mat-icon class="no-image">image_not_supported</mat-icon>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nazwa</th>
          <td mat-cell *matCellDef="let item"><strong>{{ item.name }}</strong></td>
        </ng-container>
        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef>Punkty</th>
          <td mat-cell *matCellDef="let item">{{ item.score ?? '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Ilość prod.</th>
          <td mat-cell *matCellDef="let item">{{ item.amount }}</td>
        </ng-container>
        <ng-container matColumnDef="sort">
          <th mat-header-cell *matHeaderCellDef>Sort</th>
          <td mat-cell *matCellDef="let item; let i = index">
            <div class="sort-controls">
              <button mat-icon-button (click)="changeSort(item, 'UP')"
                title="Góra" [disabled]="i === 0"><mat-icon>arrow_upward</mat-icon></button>
                <span>{{ item.sort }}</span>
                <button mat-icon-button (click)="changeSort(item, 'DOWN')"
                  title="Dół" [disabled]="i === items.length - 1"><mat-icon>arrow_downward</mat-icon></button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="is_active">
              <th mat-header-cell *matHeaderCellDef>Aktywny</th>
              <td mat-cell *matCellDef="let item">
                <mat-icon [class.active]="item.is_active === 1">{{ item.is_active === 1 ? 'check_circle' : 'cancel'
                }}</mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="valid">
              <th mat-header-cell *matHeaderCellDef>Ważny do</th>
              <td mat-cell *matCellDef="let item">{{ item.valid ? (item.valid | date:'dd.MM.yyyy') : '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Akcje</th>
              <td mat-cell *matCellDef="let item">
                <button mat-icon-button (click)="openDialog(item)" title="Edytuj"><mat-icon>edit</mat-icon></button>
                <button mat-icon-button color="warn" (click)="delete(item)"
                  title="Usuń"><mat-icon>delete</mat-icon></button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]"
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        }
      </div>